import type { MailboxInfo } from 'owa-client-types';
import {
    isMailboxSharedOrDelegateUserMailbox,
    isSharedCoprincipalAccountEnabled,
} from 'owa-account-shared-mailbox-utils';

export function isSharedOrDelegateMailbox(mailboxInfo: MailboxInfo) {
    return isSharedCoprincipalAccountEnabled() && isMailboxSharedOrDelegateUserMailbox(mailboxInfo);
}
